import './App.css';
import Calendar from "./pages/Calendar.js";
import  {Switch, Route, BrowserRouter} from "react-router-dom";
import NewEvent from "./pages/NewEvent";
import React from "react";

function App() {
    return (
        <BrowserRouter>
            <div className="App" id={'v15'}>
                <Switch>
                    <Route exact path={'/calendar-on-react/addevent'} component={NewEvent}/>
                    <Route exact path={'/calendar-on-react/calendar'} component={Calendar}/>
                    <Route exact path={'/calendar-on-react/'} component={Calendar}/>
                </Switch>
            </div>
        </BrowserRouter>
    )
}

export default App;
